import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import SwiperClass from 'swiper/types/swiper-class';

import Overlay from '@components/Overlay';
import Slider from '@components/Slider';
import { Photo } from '@types';

interface GallerySliderProps {
  initialSlide?: number;
  onClose: () => void;
  onSlideChange: (id: number, replace?: boolean) => void;
  photos: Photo[];
}

const GallerySlider = ({
  initialSlide = 0,
  onClose,
  onSlideChange,
  photos,
}: GallerySliderProps) => {
  const location = useLocation();
  const { photoId } = useParams();

  const [controlledSwiper, setControlledSwiper] = useState<SwiperClass>(null);

  useEffect(() => {
    if (!controlledSwiper) return;
    const index = photos.findIndex(({ id }) => id === photoId);
    if (index > -1 && controlledSwiper.realIndex !== index) {
      controlledSwiper.slideToLoop(index, undefined, false);
    }
  }, [location.pathname]);

  return (
    <Overlay onClose={onClose}>
      <div className="w-full h-full px-2 desktop:px-8">
        <Slider
          initialSlide={initialSlide}
          onSlideChange={onSlideChange}
          photos={photos}
          setControlledSwiper={setControlledSwiper}
        />
      </div>
    </Overlay>
  );
};

export default GallerySlider;
